import { cashCollectionsMessages } from 'src/features/cashCollections/utils/messages';

import type { BadgeOptions } from 'src/types';

export const badgeCollectionStatusOptions: BadgeOptions = {
    paid: {
        theme: 'green',
        label: cashCollectionsMessages.cashCollectionsPaid,
    },
    collected: {
        theme: 'blue',
        label: cashCollectionsMessages.cashCollectionsCollected,
    },
    loaded: {
        theme: 'yellow',
        label: cashCollectionsMessages.cashCollectionLoaded,
    },
};
